import React from 'react';

import * as Types from 'types';
import { sprintf } from 'sprintf';
import { ArtworkTitle } from 'components/artworks/ArtworkTitle';
import { EditionStats } from 'editions/EditionDetails/EditionStats';

type Props = {
  edition: Types.EditionWithArtwork;
};

export const EditionDetailsPrimaryContent: React.FC<Props> = ({ edition }) => {
  return (
    <>
      <div className='edition-details__primary-content'>
        <div className='mb-1 key-value key-value__value'>
          {sprintf('Edition No %d', edition.editionNumber)}
        </div>
        <div className='mb-2'>
          <ArtworkTitle
            url={edition.artwork.url}
            className='artwork-header--sm'
            artwork={edition.artwork}
            titleLinks
          />
        </div>
        <EditionStats edition={edition} />
      </div>
    </>
  );
};
